import styles from '../styles/Milchee.module.css';
import GoBackSection from '../components/GoBackSection';

// Images
import milchee01 from '../images/milchee/can01.png';
import milchee02 from '../images/milchee/can02.png';
import milchee03 from '../images/milchee/can03.png';
import milchee04 from '../images/milchee/can04.png';
import milchee05 from '../images/milchee/can05.png';

export default function Gaudi() {
  return (
    <div>
      <GoBackSection section="designs"/>
      <div className={styles.magazineContainer}>
        <p className={styles.title}>Milchee - Can Beverage</p>
        <p style={{marginBottom: "30px"}}>
          <span style={{fontWeight: "800", color: "var(--color-darkblue)", paddingRight: '15px'}}>Tools used</span>
          Illustrator, Photoshop & Figma
        </p>
        <div className={styles.imagesContainer}>
            <img className={styles.magazineImage} src={milchee01}/>
            <img className={styles.magazineImage} src={milchee02}/>
            <div className={styles.smImagesContainer}>
                <img className={styles.magazineImage} src={milchee03}/>
                <img className={styles.magazineImage} src={milchee04}/>
            </div>
            <img className={styles.magazineImage} src={milchee05}/>
        </div>
      </div>
    </div>
  )
}